import { ReactElement } from "react";
import { IntegrationIcons, IntegrationName } from "../mcp/constants";
import { RiToolsFill } from "react-icons/ri";

export const getIntegrationIcon = (techName: string): ReactElement => {
  if (techName === "none") {
    return <i className="codicon codicon-shield"></i>;
  }
  return IntegrationIcons[techName as IntegrationName] || <RiToolsFill className="al-w-4 al-h-4" />;
};
